<script lang="ts">
	import { StatusBadge, StatusBadgeSize, StatusBadgeTone, Tooltip } from '@repo/commons/components'
	import { truncateLineInNode } from '@repo/commons/utils'
	import { t } from 'svelte-i18n'

	type Props = {
		row: Record<string, unknown>
		commentKey: string
	}

	const { row, commentKey }: Props = $props()

	const comments = $derived(String(row[commentKey] ?? '').trim())
	const preview = $derived(truncateLineInNode(comments, null, 24, 20, 2))
</script>

{#snippet commentsTooltip()}
	<div class="comments-tooltip">{comments}</div>
{/snippet}

{#if comments}
	<Tooltip content={commentsTooltip} position="top" tooltipSize="medium" maxWidth="320px">
		<StatusBadge
			label={preview}
			icon="comment"
			tone={StatusBadgeTone.INFORMATION}
			size={StatusBadgeSize.MEDIUM}
		/>
	</Tooltip>
{:else}
	<span class="na">{$t('ReferenceTableRowsView.noDescription')}</span>
{/if}

<style lang="postcss">
	.comments-tooltip {
		@apply max-h-40 overflow-y-auto overscroll-contain whitespace-pre-line break-words;
	}

	.na {
		@apply text-base font-normal text-[#001D33B2];
	}
</style>
